export const LOGIN_METHOD_ENUM = {
  OTP: "OTP",
  EPIN: "EPIN",
};

export const  OTP_PURPOSE_ENUM = {
  REGISTER: "REGISTER",
  LOGIN: "LOGIN",
  RESET: "RESET",
  CHANGE_NUMBER: "CHANGE_NUMBER", 			
  CHANGE_NUMBER_NEW: "CHANGE_NUMBER_NEW",	
  EMPLOYEE: "EMPLOYEE",						
  WHATSAPP: "WHATSAPP"	
}